import * as api from '../api/search';
import * as formApi from '../api/eventform';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'EVENTS/SEARCH';

export const EVENT_FORMS_FETCH_START = `${namespace}/EVENT_FORMS_FETCH_START`;
export const EVENT_FORMS_FETCH_SUCCESS = `${namespace}/EVENT_FORMS_FETCH_SUCCESS`;
export const EVENT_FORMS_FETCH_ERROR = `${namespace}/EVENT_FORMS_FETCH_ERROR`;

export const SEARCH_OPTIONS_FETCH_START = `${namespace}/SEARCH_OPTIONS_FETCH_START`;
export const SEARCH_OPTIONS_FETCH_SUCCESS = `${namespace}/SEARCH_OPTIONS_FETCH_SUCCESS`;
export const SEARCH_OPTIONS_FETCH_ERROR = `${namespace}/SEARCH_OPTIONS_FETCH_ERROR`;

export const FORM_TAGS_FETCH_START = `${namespace}/FORM_TAGS_FETCH_START`;
export const FORM_TAGS_FETCH_SUCCESS = `${namespace}/FORM_TAGS_FETCH_SUCCESS`;
export const FORM_TAGS_FETCH_ERROR = `${namespace}/FORM_TAGS_FETCH_ERROR`;

export const EVENTS_FETCH_START = `${namespace}/EVENTS_FETCH_START`;
export const EVENTS_FETCH_SUCCESS = `${namespace}/EVENTS_FETCH_SUCCESS`;
export const EVENTS_FETCH_ERROR = `${namespace}/EVENTS_FETCH_ERROR`;

export const SEARCH_EVENTS_STANDALONE_START = `${namespace}/SEARCH_EVENTS_STANDALONE_START`;
export const SEARCH_EVENTS_STANDALONE_SUCCESS = `${namespace}/SEARCH_EVENTS_STANDALONE_SUCCESS`;
export const SEARCH_EVENTS_STANDALONE_ERROR = `${namespace}/SEARCH_EVENTS_STANDALONE_ERROR`;

export const SEARCH_STAT_FETCH_START = `${namespace}/SEARCH_STAT_FETCH_START`;
export const SEARCH_STAT_FETCH_SUCCESS = `${namespace}/SEARCH_STAT_FETCH_SUCCESS`;
export const SEARCH_STAT_FETCH_ERROR = `${namespace}/SEARCH_STAT_FETCH_ERROR`;

export const EVENTS_EXPORT_START = `${namespace}/EVENTS_EXPORT_START`;
export const EVENTS_EXPORT_SUCCESS = `${namespace}/EVENTS_EXPORT_SUCCESS`;
export const EVENTS_EXPORT_ERROR = `${namespace}/EVENTS_EXPORT_ERROR`;

export const CLEAR_EVENTS = `${namespace}/CLEAR_EVENTS`;

export const fetchEventForms = makeApiActionCreatorV3(
  formApi.fetchEventForms,
  EVENT_FORMS_FETCH_START,
  EVENT_FORMS_FETCH_SUCCESS,
  EVENT_FORMS_FETCH_ERROR,
);

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  SEARCH_OPTIONS_FETCH_START,
  SEARCH_OPTIONS_FETCH_SUCCESS,
  SEARCH_OPTIONS_FETCH_ERROR,
);

export const fetchFormTags = makeApiActionCreatorV3(
  formApi.fetchFormTags,
  FORM_TAGS_FETCH_START,
  FORM_TAGS_FETCH_SUCCESS,
  FORM_TAGS_FETCH_ERROR,
);

export const fetchEvents = makeApiActionCreatorV3(
  api.fetchEvents,
  EVENTS_FETCH_START,
  EVENTS_FETCH_SUCCESS,
  EVENTS_FETCH_ERROR,
);

export const searchEventsStandalone = makeApiActionCreatorV3(
  api.searchEventsStandalone,
  SEARCH_EVENTS_STANDALONE_START,
  SEARCH_EVENTS_STANDALONE_SUCCESS,
  SEARCH_EVENTS_STANDALONE_ERROR,
);

export const fetchSearchStat = makeApiActionCreatorV3(
  api.fetchSearchStat,
  SEARCH_STAT_FETCH_START,
  SEARCH_STAT_FETCH_SUCCESS,
  SEARCH_STAT_FETCH_ERROR,
);

export const exportEvents = makeApiActionCreatorV3(
  api.exportEvents,
  EVENTS_EXPORT_START,
  EVENTS_EXPORT_SUCCESS,
  EVENTS_EXPORT_ERROR,
);

export const CLEAR_SEARCH_OPTIONS = `${namespace}/CLEAR_SEARCH_OPTIONS`;
export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;
export const CHANGE_FILTER_MODEL = `${namespace}/CHANGE_FILTER_MODEL`;
export const SET_CRITERIA = `${namespace}/SET_CRITERIA`;

export function clearSearchOptions() {
  return async dispatch => {
    dispatch({ type: CLEAR_SEARCH_OPTIONS });
  };
}

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const changeSortModel = model => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const changeFilterModel = model => ({
  type: CHANGE_FILTER_MODEL,
  payload: model,
});

export const clearEvents = () => ({
  type: CLEAR_EVENTS,
});

export const setCriteria = criteria => ({
  type: SET_CRITERIA,
  payload: criteria,
});

export const EVENTS_SEARCH_PARAMS_FETCH = createRequestTypes(
  `${namespace}/EVENTS_SEARCH_PARAMS_FETCH`,
);

export const fetchEventsSearchParams = makeApiActionCreatorV3(
  api.fetchEventsSearchParams,
  EVENTS_SEARCH_PARAMS_FETCH[START],
  EVENTS_SEARCH_PARAMS_FETCH[SUCCESS],
  EVENTS_SEARCH_PARAMS_FETCH[ERROR],
);

export const EVENTS_SEARCH_PARAM_INSERT = createRequestTypes(
  `${namespace}/EVENTS_SEARCH_PARAM_INSERT`,
);

export const insertEventsSearchParam = makeApiActionCreatorV3(
  api.insertEventsSearchParam,
  EVENTS_SEARCH_PARAM_INSERT[START],
  EVENTS_SEARCH_PARAM_INSERT[SUCCESS],
  EVENTS_SEARCH_PARAM_INSERT[ERROR],
);

export const EVENTS_SEARCH_PARAM_UPDATE = createRequestTypes(
  `${namespace}/EVENTS_SEARCH_PARAM_UPDATE`,
);

export const updateEventsSearchParam = makeApiActionCreatorV3(
  api.updateEventsSearchParam,
  EVENTS_SEARCH_PARAM_UPDATE[START],
  EVENTS_SEARCH_PARAM_UPDATE[SUCCESS],
  EVENTS_SEARCH_PARAM_UPDATE[ERROR],
);

export const EVENTS_SEARCH_PARAM_DELETE = createRequestTypes(
  `${namespace}/EVENTS_SEARCH_PARAM_DELETE`,
);

export const deleteEventsSearchParam = makeApiActionCreatorV3(
  api.deleteEventsSearchParam,
  EVENTS_SEARCH_PARAM_DELETE[START],
  EVENTS_SEARCH_PARAM_DELETE[SUCCESS],
  EVENTS_SEARCH_PARAM_DELETE[ERROR],
);

export const EVENTS_SEARCH_PARAM_DUPLICATE = createRequestTypes(
  `${namespace}/EVENTS_SEARCH_PARAM_DUPLICATE`,
);

export const duplicateEventsSearchParam = makeApiActionCreatorV3(
  api.duplicateEventsSearchParam,
  EVENTS_SEARCH_PARAM_DUPLICATE[START],
  EVENTS_SEARCH_PARAM_DUPLICATE[SUCCESS],
  EVENTS_SEARCH_PARAM_DUPLICATE[ERROR],
);

export const EVENTS_SEARCH_PARAM_RESET = `${namespace}/EVENTS_SEARCH_PARAM_RESET`;

export const resetEventsSearchParam = () => ({
  type: EVENTS_SEARCH_PARAM_RESET,
});

export const EVENTS_SEARCH_PARAM_SET = `${namespace}/EVENTS_SEARCH_PARAM_SET`;

export const setEventsSearchParam = searchParamID => ({
  type: EVENTS_SEARCH_PARAM_SET,
  searchParamID,
});
